export const getEnvironmentVariable = (variable_name) => {
    const env = process.env.REACT_APP_RUNTIME_ENV || "development";
    
    if (env == 'NGINX')
        return window._env_[variable_name];

    return process.env[variable_name]
}
